const permCheck = (perm) => {
  const permission = JSON.parse(localStorage.getItem('permission'));
  if (permission !== null && permission?.length !== null) {
    if (permission.includes('superadmin') || permission.includes(perm)) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export default permCheck;
